import { render, staticRenderFns } from "./DocumentSelectors.vue?vue&type=template&id=b13c3270&scoped=true"
import script from "./DocumentSelectors.vue?vue&type=script&lang=js"
export * from "./DocumentSelectors.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelectors.vue?vue&type=style&index=0&id=b13c3270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13c3270",
  null
  
)

export default component.exports